<template>
  <div class="home">
    <b-modal
      :busy="saving"
      id="modal-1"
      :title="user.name +' '+ user.surname +' - Edit'"
      v-if="!loading"
      @ok="onSave"
      :disabled="saving"
    >
      <b-form @submit.prevent.stop="onSave">
        <b-form-group>
          <b-form-input id="name" type="text" required placeholder="Name" v-model="form.name"></b-form-input>
        </b-form-group>

        <b-form-group>
          <b-form-input
            id="surname"
            type="text"
            required
            placeholder="Surname"
            v-model="form.surname"
          ></b-form-input>
        </b-form-group>

        <b-form-group>
          <b-form-input id="email" type="email" required placeholder="Email" v-model="form.email"></b-form-input>
        </b-form-group>

        <b-form-group>
          <b-form-input
            id="phoneNumber"
            type="number"
            required
            placeholder="Phone Number"
            v-model="form.phoneNumber"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Groups">
          <b-form-select multiple :options="userGroups" :select-size="4" v-model="form.groups"></b-form-select>
        </b-form-group>

        <b-form-group>
          <div class="row">
            <div class="col-sm-6">
              <b-form-checkbox id="isReady" v-model="form.isReady">Profile Ready</b-form-checkbox>
            </div>

            <div class="col-sm-6">
              <b-form-checkbox id="isEmailValid" v-model="form.isEmailValid">Email Valid</b-form-checkbox>
            </div>
          </div>
        </b-form-group>
      </b-form>
    </b-modal>

    <loader v-if="loading"></loader>
    <div v-else>
      <div class="card mt-2">
        <div class="card-body">
          <div class="row">
            <div class="col-md-8">
              <h5 class="card-title">
                {{user.name}} {{user.surname}}
                <span v-for="group in user.groups" :key="group.id">
                  <group :group="group" />
                </span>
                <a href="#">
                  <b-icon icon="pencil-square" v-b-modal.modal-1></b-icon>
                </a>
              </h5>

              <div class="row">
                <div class="col-lg-6">
                  <dl class="row">
                    <dt class="col-sm-3">Phone:</dt>
                    <dd class="col-sm-9">{{user.phoneNumber}}</dd>
                    <dt class="col-sm-3">Email:</dt>
                    <dd class="col-sm-9">{{user.email}}</dd>
                  </dl>
                </div>
                <div class="col-lg-6">
                  <dl class="row">
                    <dt class="col-sm-5">Profile Ready:</dt>
                    <dd class="col-sm-7">{{user.isReady}}</dd>
                    <dt class="col-sm-5">Email Valid:</dt>
                    <dd class="col-sm-7">{{user.isEmailValid}}</dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <ul class="list-group">
                <li
                  class="list-group-item text-center"
                >Register Date: {{ user.createdAt | moment("MMMM Do YYYY") }}</li>
                <li
                  class="list-group-item text-center"
                >Last Update Date: {{ user.updatedAt | moment("MMMM Do YYYY") }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <b-card no-body class="mt-3">
        <div class="tabs">
          <div class="card-header">
            <ul class="nav nav-tabs card-header-tabs">
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :class="{'nav-link': true, 'active': $route.name === 'userDetail'}"
                  :to="{ name: 'userDetail', params: { userId: $route.params.id }}"
                >Notes</router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :class="{'nav-link': true, 'active': $route.name === 'UserSessions'}"
                  :to="{ name: 'UserSessions', params: { userId: $route.params.id }}"
                >Sessions</router-link>
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :class="{'nav-link': true, 'active': $route.name === 'UserPermissions'}"
                  :to="{ name: 'UserPermissions', params: { userId: $route.params.id }}"
                >Permissions</router-link>
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :class="{'nav-link': true, 'active': $route.name === 'UserCards'}"
                  :to="{ name: 'UserCards', params: { userId: $route.params.id }}"
                >Cards</router-link>
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :class="{'nav-link': true, 'active': $route.name === 'UserTrips'}"
                  :to="{ name: 'UserTrips', params: { userId: $route.params.id }}"
                >Trips</router-link>
              </li>
              <b-nav-item-dropdown
                :toggle-class="{'nav-link-custom': true, 'active': $route.matched[2] && $route.matched[2].path === '/users/:id/driver'}"
                text="Driver"
              >
                <b-dropdown-item
                  :active="$route.name === 'UserVehicles'"
                  :to="{ name: 'UserVehicles', params: { userId: $route.params.id }}"
                >Vehicles</b-dropdown-item>
                <b-dropdown-item
                  :active="$route.name === 'UserCompany'"
                  :to="{ name: 'UserCompany', params: { userId: $route.params.id }}"
                >Company Info</b-dropdown-item>
                <b-dropdown-item
                  :active="$route.name === 'DriverMemberships'"
                  :to="{ name: 'DriverMemberships', params: { userId: $route.params.id }}"
                >Driver Memberships</b-dropdown-item>
                <b-dropdown-item
                  :active="$route.name === 'DriverMembershipsPayments'"
                  :to="{ name: 'DriverMembershipsPayments', params: { userId: $route.params.id }}"
                >Driver Memberships Payments</b-dropdown-item>
                <b-dropdown-item
                  :active="$route.name === 'DriverStatus'"
                  :to="{ name: 'DriverStatus', params: { userId: $route.params.id }}"
                >Online Status</b-dropdown-item>
                <b-dropdown-item
                  :active="$route.name === 'DriverTrips'"
                  :to="{ name: 'DriverTrips', params: { userId: $route.params.id }}"
                >Driver Trips</b-dropdown-item>
                <b-dropdown-item
                  :active="$route.name === 'DriverEarnings'"
                  :to="{ name: 'DriverEarnings', params: { userId: $route.params.id }}"
                >Driver Earnings</b-dropdown-item>
                <b-dropdown-item
                  :active="$route.name === 'DriverActions'"
                  :to="{ name: 'DriverActions', params: { userId: $route.params.id }}"
                >Driver Actions</b-dropdown-item>
              </b-nav-item-dropdown>
            </ul>
          </div>
          <div class="tab-content">
            <router-view />
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import GetUser from "../../../store/actions/getUser";
import PatchUser from "../../../store/actions/patchUser";
import ShowError from "../../../helpers/showError";
import ContentLoader from "../../../components/ContentLoader";
import GroupRender from "../../../components/GroupRender";

export default {
  name: "UserDetail",
  components: {
    loader: ContentLoader,
    group: GroupRender
  },
  data() {
    return {
      saving: false,
      loading: true,
      user: undefined,
      form: {},
      userGroups: this.$store.state.groups.map(item => ({
        text: item.title,
        value: { id: item.id, title: item.title, description: item.description }
      }))
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    async getUser() {
      try {
        this.loading = true;
        const result = await GetUser(this.$route.params.id);
        this.user = result;
        this.form = { ...result };
      } catch (e) {
        ShowError(this, e);
      } finally {
        this.loading = false;
      }
    },
    async onSave() {
      try {
        this.saving = true;
        await PatchUser(
          {
            name: this.form.name,
            surname: this.form.surname,
            phoneNumber: this.form.phoneNumber,
            email: this.form.email,
            groups: this.form.groups,
            isReady: this.form.isReady,
            isEmailValid: this.form.isEmailValid
          },
          this.$route.params.id
        );
        this.getUser();
      } catch (e) {
        ShowError(this, e);
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
